export default "__VITE_ASSET__Bm$ztk43__"